import React, { useEffect, useState, useRef } from 'react'
import PageHead from '../../Components/PageHead'
import Tab from "../../Components/Tab";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRightLeft, faXmark, faPencilAlt } from '@fortawesome/free-solid-svg-icons';
import useConfig from '../../Hooks/useConfig';
import { CamelCaseWithSpaces, GetAllSchoolsByLocation, getTypeWatchDelay, normalizeToSnakeCaseWithSpecialChar, onKeyDownRestrict, onPasteRestriction, transformNameOfCol, typewatch } from '../../JS/Common';
import { ApiGetCall, ApiGetHeaders, ApiPostCall } from '../../JS/Connector';
import Popup from '../../Components/Popup';
import Pagination from "react-js-pagination";
import { CheckValidation } from '../../Components/Validations';
import AlertsComp from '../../Components/AlertsComp';
import CustomFontAwesomeIcon from '../../Components/CustomFontAwesomeIcon';
import { log } from '../../JS/Logger';
import { useNavigate } from 'react-router-dom';
import CustomizationPopup from '../../Components/CustomizationPopup';
import AlertPopup from '../../Components/AlertPopup';
import { useStickyAction } from '../../Hooks';

function resolveSelection(id, name, list) {
    const trimmedName = (name || '').trim();

    const matchById = id != null ? list.find(item => item.id === id) : null;

    const matched = matchById;

    return {
        value: matched ? matched.id : 'other',
        inputName: trimmedName
    };
}

export default function DeviceModels() {
    const { organization, no_organization_found, adminCallNode, show_import_export_nav_btn } = useConfig();
    const [loading, setLoading] = useState(false);
    const [NewAlerts, setNewAlerts] = useState('');
    const [Locations, setLocations] = useState([]);
    const [SchoolFilterData, setSchoolFilterData] = useState([]);
    const [SchoolId, setSchoolId] = useState(0)
    const [AllSchool, setAllSchool] = useState([]);
    const [gridData, setGridData] = useState([]);
    const [modelData, setmodelData] = useState([]);

    const initialModelState = {
        show: false,
        editId: null,
        data: null,
        addUpdateApprovalFlag: null,
        approveShow: false,
        isMerge: false,
        sourceModelId: null,
        targetModelId: null
    }
    const [showAddModelPopup, setShowAddModelPopup] = useState(initialModelState);

    const [currentPage, setCurrentPage] = useState(1);
    const [LimitForPagination, setLimitForPagination] = useState(25);
    const showPagination = gridData.length > 0;
    const [pageRangeCount, setpageRangeCount] = useState(0);
    const [SearchString, setSearchString] = useState('');
    const [manufactererData, setManufactererData] = useState([]);

    const initialNewDeviceData = {
        DeviceManufacturer: '',
        NewDeviceManufacturer: '',
        NewDeviceModel: '',
        DeviceModel: '',
        schoolName: '',
        unChangedModel: '',
        unChangedManfacturer: '',
        unChangedDeviceCount: '',
    }
    const [newDeviceData, setNewDeviceData] = useState(initialNewDeviceData);

    const [sortBy, setSortBy] = useState({
        sortColumn: '',
        sortDirection: 'asc'
    });
    const [tabs, setTabs] = useState({
        UnmatchedModels: 'active',
        ApprovedModels: '',
    });

    const initialAllParts = {
        data: [],
        loader: false,
        showSuggestionBox: false,
        searchString: "",
    }
    const [allParts, setAllPartsData] = useState(initialAllParts);

    const [CustomizationModal, setCustomizationModal] = useState(false);
    const navigate = useNavigate();
    const [selectedPartIds, setSelectedPartIds] = useState([]);
    const [columnNames, setColumnNames] = useState([]);
    const [selectedPartForApproval, setSelectedPartForApproval] = useState({
        data: null,
        showPopup: false
    });
    const [serialNumbersList, setSerialNumbersList] = useState([]);

    const pendingModelMatch = useRef(null);
    const manufacturerInputRef = useRef(null);
    const modelInputRef = useRef(null);

    const initialDeleteModelPopup = {
        show: false,
        model: null,
        action: "replace",
        manufacturerId: "",
        modelId: ""
    };
    const [deleteModelPopup, setDeleteModelPopup] = useState(initialDeleteModelPopup);
    const { tableWrapperRef, isOverflowing } = useStickyAction(columnNames);

    function renderContentForColumn(columnName, item) {
        const contentMap = {
            "school_name": item.school_name,
            "device_manufacturer": item.device_manufacturer,
            "device_model": item.device_model,
            "total_devices": item.total_devices,
            "serial_number": item.serial_number
        };
        return contentMap[columnName] || ' - ';
    }

    const getGridData = async () => {
        try {
            typewatch(async function () {
                setLoading(true);
                await ApiGetCall(`/device/models/list?flag=${tabs?.ApprovedModels === 'active' ? 2 : 1}&search=${SearchString}&school_id=${SchoolId || 0}&sort_by=${sortBy?.sortColumn}&sort_dir=${sortBy?.sortDirection}&page=${currentPage}&limit=${LimitForPagination}`).then((result) => {
                    if (result == undefined || result == "") {
                        alert("Something went wrong");
                    } else {
                        const responseRs = normalizeToSnakeCaseWithSpecialChar(JSON.parse(result));
                        setGridData(responseRs?.msg?.data || []);
                        setpageRangeCount(responseRs?.msg?.total || 0);
                        setLoading(false);
                    }
                });
            }, getTypeWatchDelay(SearchString, 1000))
        } catch (e) {
            log.error("Error fetching grid data:", e);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        ApiGetHeaders(47, setColumnNames)
        GetAllSchoolsByLocation({ setLocations, setSchoolFilterData, setAllSchool })
    }, []);

    useEffect(() => {
        getGridData();
    }, [tabs, SchoolId, LimitForPagination, currentPage, SearchString, sortBy]);

    useEffect(() => {
        getManufacturerData()
    }, [])

    useEffect(() => {
        if (!pendingModelMatch.current) return;

        const { id, name } = pendingModelMatch.current;
        const modelMatch = resolveSelection(id, name, modelData || []);

        setNewDeviceData(prev => ({
            ...prev,
            DeviceModel: modelMatch.value,
            NewDeviceModel: modelMatch.inputName
        }));

        pendingModelMatch.current = null;
    }, [modelData]);

    const getManufacturerData = async () => {
        try {
            await ApiGetCall(`/device-manufacturers`).then((result) => {
                if (result == undefined || result == "") {
                    alert("Something went wrong");
                } else {
                    const responseRs = JSON.parse(result);
                    setManufactererData(responseRs)
                }
            })
        } catch (error) {
            log.error(error)
        }
    }

    async function GetRepairParts(searchString) {
        if (searchString?.trim() == "" || searchString == undefined) {
            setAllPartsData(prev => ({ ...prev, loader: false }));
            searchString = null;
        } else {
            searchString = searchString?.trim() || null;
        }
        setAllPartsData(prev => ({ ...prev, loader: true, showSuggestionBox: searchString && true }));
        typewatch(async function () {
            await ApiGetCall(`${adminCallNode}/parts/all?search=${searchString}&ticketId=${null}&seeMore=${0}`).then((result) => {
                if (result == undefined || result == "") {
                    alert("Something went wrong");
                } else {
                    const responseRs = JSON.parse(result);
                    if (responseRs.response == "success") {
                        setAllPartsData(prev => ({ ...prev, data: responseRs.msg, loader: false }));
                    } else {
                        setAllPartsData(prev => ({ ...prev, data: [], loader: false }));
                    }
                }
            });
        }, 1000);
    }

    const getDeviceModelDetailsById = async (id) => {
        setLoading(true);
        await ApiGetCall(`/device-model-parts?deviceModelId=${id}`).then((result) => {
            if (result == undefined || result == "") {
                setLoading(false);
                alert("Something went wrong");
            } else {
                setLoading(false);
                const responseRs = JSON.parse(result);
                if (responseRs?.response == "success") {
                    const details = responseRs?.data;
                    setNewDeviceData(prev => ({
                        ...prev,
                        DeviceManufacturer: details?.manufacturer_id || "",
                        NewDeviceManufacturer: details?.manufacturer_name || "",
                        NewDeviceModel: details?.name || ""
                    }));
                    setSelectedPartIds(details?.parts || []);
                }
            }
        });
    }

    const getApprovalModelDetails = async (schoolId, flag, deviceModelId, manufactuerId) => {
        setLoading(true);
        await ApiGetCall(`/device-models/details?schoolId=${schoolId}&flag=${flag}&deviceModelId=${deviceModelId}&manufacturerId=${manufactuerId}`).then((result) => {
            if (result == undefined || result == "") {
                setLoading(false);
                alert("Something went wrong");
                return;
            }
            setLoading(false);
            const responseRs = JSON.parse(result);
            if (responseRs?.response != "success") return;

            const details = responseRs?.msg;
            const manufacturerMatch = resolveSelection(
                details?.device_manufacturer_id ?? null,
                details?.device_manufacturer,
                manufactererData
            );

            setNewDeviceData(prev => ({
                ...prev,
                DeviceManufacturer: manufacturerMatch.value,
                NewDeviceManufacturer: manufacturerMatch.inputName,
                unChangedManfacturer: details?.device_manufacturer || "",
                unChangedModel: details?.device_model || "",
                schoolName: details?.school_name || "",
                unChangedDeviceCount: details?.devices?.length || 0
            }));
            setSerialNumbersList(details?.devices || []);

            if (manufacturerMatch.value === 'other') {
                setmodelData([]);
                pendingModelMatch.current = null;
                setNewDeviceData(prev => ({
                    ...prev,
                    DeviceModel: 'other',
                    NewDeviceModel: (details?.device_model || '').trim()
                }));
            } else {
                pendingModelMatch.current = {
                    id: details?.device_model_id ?? null,
                    name: details?.device_model || ''
                };
                getModelsFromManufacturer(manufacturerMatch.value);
            }
        });
    }

    const handlesave = async (saveType) => {
        const isFormValid = CheckValidation({ formID: 'AddModelForm' });
        if (!isFormValid) return;

        // if (saveType == 1) {
        //     if (selectedPartIds?.length === 0) {
        //         setNewAlerts(<AlertsComp show={true} variant={"danger"} msg={"Please attach at least one part."} />)
        //         setTimeout(() => {
        //             setNewAlerts(<AlertsComp show={false} />)
        //         }, 2000);
        //         return;
        //     }
        // }

        const raw = JSON.stringify({
            deviceManufacturerId: newDeviceData?.DeviceManufacturer === 'other' ? 0 : newDeviceData?.DeviceManufacturer,
            deviceManufacturer: newDeviceData?.NewDeviceManufacturer,
            deviceModel: newDeviceData?.NewDeviceModel,
            devicePartIds: selectedPartIds?.map(p => p.part_id) || [],
            addUpdateFlag: saveType,
            deviceModelId: showAddModelPopup?.editId || null,
            sourceModelId: showAddModelPopup?.sourceModelId || null,
            targetModelId: showAddModelPopup?.targetModelId || null,
        })
        setLoading(true)
        await ApiPostCall(`/save-manufacturer-model`, raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false)
                const responseRs = JSON.parse(result);
                if (responseRs?.response == "success") {
                    setNewAlerts(<AlertsComp show={true} variant='success' msg={responseRs?.message} />)
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />)
                    }, 2000);
                    setShowAddModelPopup(initialModelState);
                    setSelectedPartIds([]);
                    setAllPartsData(initialAllParts);
                    setNewDeviceData(initialNewDeviceData);
                    getManufacturerData();
                    getGridData();
                } else {
                    if (responseRs?.is_merge == true) {
                        setShowAddModelPopup(prev => ({
                            ...prev,
                            isMerge: true,
                            sourceModelId: responseRs?.source_model_id,
                            targetModelId: responseRs?.target_model_id
                        }))
                    } else {
                        setNewAlerts(<AlertsComp show={true} variant='danger' msg={responseRs?.message} />)
                        setTimeout(() => {
                            setNewAlerts(<AlertsComp show={false} />)
                        }, 2000);
                    }
                }

            }
        })
    }

    const handleApprove = async () => {
        const isFormValid = CheckValidation({ formID: 'AddModelForm' });
        if (!isFormValid) return;

        if (serialNumbersList?.length == 0) {
            setNewAlerts(<AlertsComp show={true} msg={'Their must be at least one serial number to convert'} variant='danger' />);
            setTimeout(() => {
                setNewAlerts(<AlertsComp show={false} />)
            }, 2000);
            return;
        }

        const raw = JSON.stringify({
            targetDeviceManufacturerId: newDeviceData?.DeviceManufacturer === 'other' || newDeviceData?.DeviceManufacturer === '' ? 0 : newDeviceData?.DeviceManufacturer,
            targetDeviceModelId: newDeviceData?.DeviceModel === 'other' || newDeviceData?.DeviceModel === '' ? 0 : newDeviceData?.DeviceModel,
            inventoryIds: serialNumbersList?.map(p => p.id) || [],
            deviceManufacturer: newDeviceData.NewDeviceManufacturer,
            deviceModel: newDeviceData.NewDeviceModel
        })
        setLoading(true)
        await ApiPostCall(`/convert-device-models`, raw).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                setLoading(false)
                const responseRs = JSON.parse(result);
                if (responseRs?.response == "success") {
                    setNewAlerts(<AlertsComp show={true} variant='success' msg={responseRs?.message} />)
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />)
                    }, 2000);

                    setNewDeviceData(initialNewDeviceData);
                    setmodelData([]);
                    setSerialNumbersList([]);
                    pendingModelMatch.current = null;
                    setShowAddModelPopup(initialModelState);
                    setSelectedPartIds([]);
                    setAllPartsData(initialAllParts);
                    getManufacturerData();
                    getGridData();
                } else {
                    setNewAlerts(<AlertsComp show={true} variant='danger' msg={responseRs?.message} />)
                    setTimeout(() => {
                        setNewAlerts(<AlertsComp show={false} />)
                    }, 2000);
                }

            }
        })
    }

    const handleTabClick = (tabtype) => {
        setSchoolId(0);
        setCurrentPage(1);
        setSearchString('');
        setSortBy(prev => ({ ...prev, sortColumn: '', sortDirection: 'asc' }));
        if (tabtype == "UnmatchedModels") {
            setTabs({ ...tabs, UnmatchedModels: 'active', ApprovedModels: '' });
        } else if (tabtype == "ApprovedModels") {
            setTabs({ ...tabs, UnmatchedModels: '', ApprovedModels: 'active' });
        }
    }

    const AddSelectedPartIds = (isCheckboxState, partDetails) => {
        setSelectedPartIds(prev => {
            if (isCheckboxState) {
                if (prev.some(p => p.part_id === partDetails.id)) return prev;
                return [...prev, { part_id: partDetails.id, name: partDetails.title }];
            } else {
                return prev.filter(p => p.part_id !== partDetails.id);
            }
        });
    }

    const getModelsFromManufacturer = async (id) => {
        setLoading(true)
        await ApiGetCall(`/device-models?uuid=${id || null}`).then((result) => {
            setLoading(false)
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                setmodelData(responseRs)
            }
        })
    }

    const modalBodyAddEdit = (
        <>
            <div className="row" id='AddModelForm'>
                <div className='col-md-12 mb-2'>
                    <label className='fw-semibold font-16'>
                        Select Manufacturer & Model
                    </label>
                </div>
                <div className="col-md-6 parent">
                    <label htmlFor="">Device Manufacturer<span className='redText'>*</span></label>
                    {showAddModelPopup?.addUpdateApprovalFlag == 2 ? (
                        <>
                            <input className='form-control mt-2' type="text"
                                placeholder='Enter Manufacturer' required maxLength={100}
                                value={newDeviceData.NewDeviceManufacturer}
                                onChange={(e) => { setNewDeviceData(prev => ({ ...prev, NewDeviceManufacturer: e.target.value })) }} />
                            <span className="form-text invalid-feedback">
                                *required
                            </span>
                        </>
                    ) : (
                        <>
                            <select className='mt-2 form-select' value={newDeviceData.DeviceManufacturer}
                                required
                                onChange={(e) => {
                                    setNewDeviceData(prev => ({
                                        ...prev,
                                        DeviceManufacturer: e.target.value,
                                        NewDeviceManufacturer: '',
                                        NewDeviceModel: '',
                                        DeviceModel: ''
                                    }));

                                    if (e.target.value !== 'other') {
                                        getModelsFromManufacturer(e.target.value);
                                    }
                                }}>
                                <option value="">Select Manufacturer</option>
                                {manufactererData?.map((item1, j) => (
                                    <option value={item1.id} key={j}>
                                        {item1.name}
                                    </option>
                                ))}
                                <option value={'other'}>Other</option>
                            </select>
                            <span className="form-text invalid-feedback">
                                *required
                            </span>
                            {newDeviceData?.DeviceManufacturer === 'other' &&
                                <div className='parent'>
                                    <input className='form-control mt-3' type="text" name="" id=""
                                        placeholder='Enter Manufacturer' required maxLength={100}
                                        value={newDeviceData.NewDeviceManufacturer}
                                        onChange={(e) => { setNewDeviceData(prev => ({ ...prev, NewDeviceManufacturer: e.target.value })) }} />
                                    <span className="form-text invalid-feedback">
                                        *required
                                    </span>
                                </div>
                            }
                        </>
                    )}
                </div>
                <div className="col-md-6 parent">
                    <label htmlFor="">Device Model<span className='redText'>*</span></label>
                    <input className='form-control mt-2' type="text" maxLength={100}
                        value={newDeviceData.NewDeviceModel} placeholder='Enter Model' required
                        disabled={
                            (showAddModelPopup?.addUpdateApprovalFlag != 2) &&
                            ((!newDeviceData?.DeviceManufacturer) ||
                                (newDeviceData?.DeviceManufacturer === 'other' && !newDeviceData?.NewDeviceManufacturer))
                        }
                        onChange={(e) => { setNewDeviceData(prev => ({ ...prev, NewDeviceModel: e.target.value })) }} />
                    <span className="form-text invalid-feedback">*required</span>
                </div>
                <div className='col-12'>
                    <hr className='mt-3' />
                    <label className='fw-semibold mb-2 font-16'>
                        Master Parts in this Group<span className='redText'>*</span> ({selectedPartIds?.length})
                    </label>
                </div>
                <div className="col-md-12" tabIndex={-1}
                    onBlur={(e) => {
                        if (!e.currentTarget.contains(e.relatedTarget)) {
                            setAllPartsData(initialAllParts);
                        }
                    }}>
                    <input id="universal-search-box" className="form-control" autoComplete="off" type="text"
                        value={allParts.searchString} placeholder="Search master parts to add to this model"
                        onChange={(e) => {
                            setAllPartsData(prev => ({ ...prev, searchString: e.target.value }));
                            GetRepairParts(e.target.value)
                        }}
                        onPaste={onPasteRestriction}
                        onKeyDown={onKeyDownRestrict}
                    />
                    {allParts.showSuggestionBox && (
                        <div className="col-12 position-relative">
                            <div className="SuggestionBoxDiv" style={{ zIndex: 5, maxHeight: '250px' }}>
                                {allParts?.loader ?
                                    <div className='row'>
                                        <div className="col-12 text-center pt-2">
                                            <img src="/images/loder.svg" style={{ width: "30px" }} />
                                        </div>
                                    </div>
                                    : allParts?.data?.length != 0 ?
                                        allParts?.data?.map((part) => (
                                            <div tabIndex={0} className="row brdr-Btm font-14 schoolid p-Suggestion"
                                                onClick={(e) => {
                                                    if (e.target.type === 'checkbox') return;
                                                    const exists = selectedPartIds.some(p => p.part_id === part.id);
                                                    AddSelectedPartIds(!exists, part);
                                                }}>
                                                <div className="col-12 text-start d-flex align-items-center">
                                                    <input type="checkbox" className='form-check-input cursor-pointer'
                                                        checked={selectedPartIds.some(p => p.part_id === part.id)}
                                                        onChange={(e) => {
                                                            e.stopPropagation();
                                                            AddSelectedPartIds(e.target.checked, part)
                                                        }} />
                                                    <label className='ps-2 cursor-pointer'>{part.title}</label>
                                                </div>
                                            </div>
                                        ))
                                        : <div className="col-12 text-center"> <label> No Record Found </label> </div>
                                }
                            </div>
                        </div>
                    )}
                </div>
                <div className="col-md-12 mt-3" style={{ maxHeight: '250px', overflowY: 'auto' }}>
                    <div className="d-flex flex-wrap gap-2">
                        {selectedPartIds?.length > 0 &&
                            selectedPartIds?.map((partDetails) => (
                                <div className="mb-2 w-auto pe-0" key={partDetails.part_id}>
                                    <div className="BorderBtn me-0">
                                        <label className="me-2 cursor-pointer">
                                            {partDetails.name}
                                        </label>
                                        <CustomFontAwesomeIcon title="Remove Part" icon={faXmark} size="lg"
                                            onClick={() => setSelectedPartIds(prev => prev.filter(p => p.part_id !== partDetails.part_id))}
                                        />
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>
            </div>
        </>
    );

    const modalBodyApprove = (
        <>
            <div className="row" id='AddModelForm'>
                <div className='col-12 mb-3'>
                    <div className='border p-3'>
                        <label className='fw-semibold font-16'>
                            Unapproved Model Details
                            <span className="tooltip-wrapper ms-2">
                                <img
                                    src="/images/InfoIcon.svg"
                                    className="info-icon"
                                    height="14"
                                    alt="info"
                                />
                                <span className="tooltip-text">
                                    Review and approve unmatched model details and devices
                                </span>
                            </span>
                        </label>
                        <div className='d-flex greyBox p-3 mt-2 w-100'>
                            <div className='col-md-3'>
                                <label className='font-12 w-100'>{organization} Name: </label>
                                <label className='fw-semibold mt-1'>{newDeviceData.schoolName || "-"}</label>
                            </div>
                            <div className='col-md-3'>
                                <label className='font-12 w-100'>Manufacturer: </label>
                                <label className='fw-semibold mt-1 text-break'>{newDeviceData.unChangedManfacturer || "-"}</label>
                            </div>
                            <div className='col-md-3'>
                                <label className='font-12 w-100'>Model: </label>
                                <label className='fw-semibold mt-1 text-break'>
                                    {newDeviceData.unChangedModel || "-"}
                                </label>
                            </div>
                            <div className='col-md-3'>
                                <label className='font-12 w-100'>Total Devices: </label>
                                <label className='fw-semibold mt-1'>{newDeviceData.unChangedDeviceCount || "-"}</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='col-md-12 mb-2'>
                    <label className='fw-semibold font-16'>
                        Select Manufacturer & Model
                    </label>
                </div>
                <div className="col-md-6 parent">
                    <label htmlFor="">Device Manufacturer<span className='redText'>*</span></label>
                    <select className='mt-2 form-select' value={newDeviceData.DeviceManufacturer} required
                        onChange={(e) => {
                            const newManufacturerId = e.target.value;

                            if (newManufacturerId === 'other') {
                                setmodelData([]);
                                pendingModelMatch.current = null;
                                setNewDeviceData(prev => ({
                                    ...prev,
                                    DeviceManufacturer: 'other',
                                    NewDeviceManufacturer: '',
                                    DeviceModel: 'other'
                                }));
                                return;
                            }

                            const selectedManufacturer = manufactererData.find(m => String(m.id) === String(newManufacturerId));
                            pendingModelMatch.current = { id: null, name: newDeviceData.NewDeviceModel };

                            setNewDeviceData(prev => ({
                                ...prev,
                                DeviceManufacturer: newManufacturerId,
                                NewDeviceManufacturer: selectedManufacturer?.name || ''
                            }));

                            getModelsFromManufacturer(newManufacturerId);
                        }}>
                        <option value="">Select Manufacturer</option>
                        {manufactererData?.map((item1, j) => (
                            <option value={item1.id} key={j}>
                                {item1.name}
                            </option>
                        ))}
                        <option value={'other'}>Other</option>
                    </select>
                    <span className="form-text invalid-feedback">
                        *required
                    </span>
                    <div className='parent'>
                        <div className="input-group mt-2 has-validation">
                            <input ref={manufacturerInputRef} className='form-control inputOverRideBorderRight' type="text" name="" id=""
                                placeholder='Enter Manufacturer' required maxLength={100}
                                value={newDeviceData.NewDeviceManufacturer}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    const matched = manufactererData.find(m => m.name?.toLowerCase() === value.trimStart().toLowerCase());

                                    if (matched) {
                                        pendingModelMatch.current = { id: null, name: newDeviceData.NewDeviceModel };
                                        setNewDeviceData(prev => ({
                                            ...prev,
                                            DeviceManufacturer: matched.id,
                                            NewDeviceManufacturer: matched.name
                                        }));
                                        getModelsFromManufacturer(matched.id);
                                    } else {
                                        setNewDeviceData(prev => ({ ...prev, NewDeviceManufacturer: value }));
                                    }
                                }} />
                            <span className="input-group-text bg-white text-secondary cursor-pointer inputOverRideBorderLeft" onClick={() => manufacturerInputRef.current?.focus()}>
                                <FontAwesomeIcon icon={faPencilAlt} />
                            </span>
                            <span className="form-text invalid-feedback">
                                *required
                            </span>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 parent">
                    <label htmlFor="">Device Model<span className='redText'>*</span></label>
                    <select
                        disabled={!newDeviceData?.DeviceManufacturer}
                        value={newDeviceData.DeviceModel}
                        required
                        className='mt-2 form-select'
                        onChange={(e) => {
                            const newModelId = e.target.value;
                            const selectedModel = newModelId === 'other'
                                ? null
                                : modelData.find(m => String(m.id) === String(newModelId));

                            setNewDeviceData(prev => ({
                                ...prev,
                                DeviceModel: newModelId,
                                NewDeviceModel: newModelId === 'other' ? '' : (selectedModel ? selectedModel.name : prev.NewDeviceModel)
                            }));
                        }}>
                        <option value="">Select Model</option>
                        {modelData?.map((item1, j) => (
                            <option value={item1.id} key={j}>
                                {item1.name}
                            </option>
                        ))}
                        <option value={'other'}>Other</option>
                    </select>
                    <span className="form-text invalid-feedback">*required</span>
                    <div className="input-group mt-2 has-validation">
                        <input ref={modelInputRef} className='form-control inputOverRideBorderRight' type="text" maxLength={100}
                            value={newDeviceData.NewDeviceModel} placeholder='Enter Model' required
                            onChange={(e) => {
                                const value = e.target.value;
                                const matched = modelData.find(m => m.name?.toLowerCase() === value.trimStart().toLowerCase());

                                if (matched) {
                                    setNewDeviceData(prev => ({
                                        ...prev,
                                        DeviceModel: matched.id,
                                        NewDeviceModel: matched.name
                                    }));
                                } else {
                                    setNewDeviceData(prev => ({ ...prev, NewDeviceModel: value }));
                                }
                            }} />
                        <span className="input-group-text bg-white text-secondary cursor-pointer inputOverRideBorderLeft" onClick={() => modelInputRef.current?.focus()}>
                            <FontAwesomeIcon icon={faPencilAlt} />
                        </span>
                        <span className="form-text invalid-feedback">*required</span>
                    </div>
                </div>

                <div className='col-md-12'>
                    <hr className='mt-3' />
                    <label className='fw-semibold mb-2 font-16'>
                        Devices in this Group ({serialNumbersList?.length})
                    </label>

                    {serialNumbersList?.length > 0 && (
                        <div className="d-flex flex-wrap gap-2" style={{ maxHeight: '250px', overflowY: 'auto' }}>
                            {serialNumbersList
                                ?.map((serial) => (
                                    <div className="mb-2" key={serial.id}>
                                        <div className="BorderBtn me-0">
                                            <label className='cursor-pointer'>
                                                {serial.serial_number}
                                            </label>
                                        </div>
                                    </div>
                                ))}
                        </div>
                    )}
                </div>
            </div>
        </>
    );

    const modalEditFooter = (
        <div className="row align-items-center w-100">
            <div className={`${showAddModelPopup?.isMerge ? "col-7 ps-0" : "col ps-0"}`}>
                {showAddModelPopup?.isMerge && (
                    <strong className="yellow-warning-text text-left">
                        This model already exists. Would you like to merge?
                    </strong>
                )}
            </div>

            <div
                className={`${showAddModelPopup?.isMerge ? "col-5 pe-0" : "col-auto"
                    } d-flex align-items-center justify-content-end`}
            >
                <label
                    className="me-3 cursor-pointer mb-0"
                    onClick={() => {
                        setNewDeviceData(initialNewDeviceData);
                        setShowAddModelPopup(initialModelState);
                        setSelectedPartIds([]);
                        setmodelData([]);
                        setSerialNumbersList([]);
                        setAllPartsData(initialAllParts);
                    }}
                >
                    <u>Cancel</u>
                </label>

                <button
                    className="SaveBtn"
                    onClick={() =>
                        handlesave(showAddModelPopup?.isMerge ? 3 : showAddModelPopup.addUpdateApprovalFlag === 2 ? 2 : 1)
                    }
                >
                    {showAddModelPopup?.isMerge
                        ? "Merge & Update"
                        : `${showAddModelPopup.addUpdateApprovalFlag === 2 ? "Update" : "Add"} Model`}
                </button>
            </div>
        </div>
    );
    const modalBodyDeleteModel = (
        <>
            <div className="row" id="DeleteModelForm">

                {deleteModelPopup.model?.total_devices > 0 ? (
                    <>
                        <div className="col-12 mb-3 px-4">
                            <p className="mb-0">
                                This model is assigned to{" "}
                                <strong>{deleteModelPopup.model?.total_devices}</strong>{" "}
                                device(s).<br />Select an action to continue.
                            </p>
                            <hr />
                        </div>
                        <div className="col-12 mb-3 px-4">
                            <div className="d-flex align-items-center justify-content-start  gap-4">

                                <div className="form-check mb-0">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        id="replace"
                                        name="deleteOption"
                                        value="replace"
                                        checked={deleteModelPopup.action === "replace"}
                                        onChange={(e) =>
                                            setDeleteModelPopup(prev => ({
                                                ...prev,
                                                action: e.target.value,
                                                manufacturerId: "",
                                                modelId: ""
                                            }))
                                        }
                                    />

                                    <label
                                        className="form-check-label"
                                        htmlFor="replace"
                                    >
                                        Replace with another model
                                    </label>
                                </div>

                                <div className="form-check mb-0">
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        id="clear"
                                        name="deleteOption"
                                        value="clear"
                                        checked={deleteModelPopup.action === "clear"}
                                        onChange={(e) =>
                                            setDeleteModelPopup(prev => ({
                                                ...prev,
                                                action: e.target.value
                                            }))
                                        }
                                    />

                                    <label
                                        className="form-check-label"
                                        htmlFor="clear"
                                    >
                                        Clear affected devices
                                    </label>
                                </div>

                            </div>
                        </div>

                        {deleteModelPopup.action === "replace" && (
                            <div className="col-12 mt-2 px-4">
                                <div className="row align-items-start g-3 text-start">

                                    <div className="col-md-6 parent">
                                        <label className="form-label">
                                            Device Manufacturer{" "}
                                            <span className="redText">*</span>
                                        </label>

                                        <select
                                            required
                                            className="form-select location-name"
                                            style={{ maxWidth: "100%" }}
                                            value={deleteModelPopup.manufacturerId}
                                            onChange={(e) => {
                                                setDeleteModelPopup(prev => ({
                                                    ...prev,
                                                    manufacturerId: e.target.value,
                                                    modelId: ""
                                                }));

                                                getModelsFromManufacturer(e.target.value);
                                            }}
                                        >
                                            <option value="">
                                                Select Manufacturer
                                            </option>

                                            {manufactererData?.map(item => (
                                                <option
                                                    key={item.id}
                                                    value={item.id}
                                                >
                                                    {item.name}
                                                </option>
                                            ))}
                                        </select>

                                        <span className="form-text invalid-feedback">
                                            *required
                                        </span>
                                    </div>

                                    <div className="col-md-6 parent">
                                        <label className="form-label">
                                            Device Model{" "}
                                            <span className="redText">*</span>
                                        </label>

                                        <select
                                            required
                                            className="form-select location-name"
                                            style={{ maxWidth: "100%" }}
                                            value={deleteModelPopup.modelId}
                                            disabled={!deleteModelPopup.manufacturerId}
                                            onChange={(e) =>
                                                setDeleteModelPopup(prev => ({
                                                    ...prev,
                                                    modelId: e.target.value
                                                }))
                                            }
                                        >
                                            <option value="">
                                                Select Device Model
                                            </option>

                                            {modelData
                                                ?.filter(item => item.id !== deleteModelPopup.model?.id)
                                                .map(item => (
                                                    <option
                                                        key={item.id}
                                                        value={item.id}
                                                    >
                                                        {item.name}
                                                    </option>
                                                ))
                                            }
                                        </select>

                                        <span className="form-text invalid-feedback">
                                            *required
                                        </span>
                                    </div>

                                </div>
                            </div>
                        )}
                    </>
                ) : (
                    <div className="col-12">
                        <p className="mb-0">
                            Are you sure you want to delete this device model?
                        </p>
                    </div>
                )}

            </div>
        </>
    );
    const handleDeleteModel = async () => {

        let payload = {
            deviceModelId: deleteModelPopup.model.id,
            targetDeviceModelId: null,
            flag: 1
        };

        if (deleteModelPopup.model.total_devices > 0) {

            if (deleteModelPopup.action === "replace") {

                const isFormValid = CheckValidation({ formID: "DeleteModelForm" });
                if (!isFormValid) return;

                payload.flag = 3;
                payload.targetDeviceModelId = deleteModelPopup.modelId;
            }
            else {
                payload.flag = 2;
            }
        }
        const raw = JSON.stringify(payload)
        setLoading(true);

        await ApiPostCall("/device-models/delete", raw).then((result) => {

            setLoading(false);

            if (result == undefined || result == "") {
                alert("Something went wrong");
                return;
            }

            const responseRs = JSON.parse(result);

            if (responseRs?.response == "success") {

                setNewAlerts(
                    <AlertsComp
                        show={true}
                        variant="success"
                        msg={responseRs?.message}
                    />
                );

                setTimeout(() => {
                    setNewAlerts(<AlertsComp show={false} />);
                }, 2000);

                setDeleteModelPopup(initialDeleteModelPopup);
                getGridData();
            }
            else {

                setNewAlerts(
                    <AlertsComp
                        show={true}
                        variant="danger"
                        msg={responseRs?.message}
                    />
                );

                setTimeout(() => {
                    setNewAlerts(<AlertsComp show={false} />);
                }, 2000);
            }

        }).catch(() => {

            setLoading(false);

            setNewAlerts(
                <AlertsComp
                    show={true}
                    variant="danger"
                    msg="Something went wrong."
                />
            );

            setTimeout(() => {
                setNewAlerts(<AlertsComp show={false} />);
            }, 2000);
        });
    };
    return (
        <div>
            <PageHead heading={`Device Models`} handleSearch={(e) => { setSearchString(e.target.value); setCurrentPage(1); }} LimitForPagination={LimitForPagination} setLimitForPagination={setLimitForPagination} setCurrentPage={setCurrentPage}
                loading={loading} Alerts={NewAlerts} showsearch={true} />

            <div className="GridBox mt-2 p-3">
                <div className="row align-items-center mb-3">
                    <div className="col-md-6 px-0">
                        <ul className="nav nav-tabs px-3">
                            <Tab isActive={tabs.UnmatchedModels == 'active'}
                                label="Unmatched Models" onClick={() => handleTabClick("UnmatchedModels")} />
                            <Tab isActive={tabs.ApprovedModels == 'active'}
                                label="Approved Models" onClick={() => handleTabClick("ApprovedModels")} />
                        </ul>
                    </div>
                    <div className="col-md-6 text-end pe-0">
                        {tabs.ApprovedModels === 'active' ? (
                            <>
                                {show_import_export_nav_btn && (
                                    <label title='Import & Export Models' className="BorderBtn p-2 me-3 text-center" onClick={() => { navigate('/import-export') }}>
                                        <FontAwesomeIcon icon={faRightLeft} className="pe-2" />
                                        Import & Export Models
                                    </label>
                                )}
                                <label className="BorderBtn text-end me-3 mt-0" title="Add New Model"
                                    onClick={() => {
                                        getManufacturerData();
                                        setShowAddModelPopup(prev => ({ ...prev, show: true, editId: null, addUpdateApprovalFlag: 1, data: null }));
                                    }}
                                >
                                    Add New Model <img src='/images/AddInventory.svg' className='img-fluid ps-2' />
                                </label>
                            </>
                        ) :
                            <>
                                <select value={SchoolId} className='w-auto h-100 me-3'
                                    onChange={(e) => { setSchoolId(e.target.value); setCurrentPage(1); }}>
                                    <option value="0">Filter by {organization}</option>
                                    {AllSchool?.length == 0 && <optgroup label={no_organization_found}></optgroup>}
                                    {AllSchool?.map((item, j) => (
                                        <option value={item.id} key={j}>
                                            {item.name}
                                        </option>
                                    ))}
                                </select>
                            </>
                        }
                    </div>
                </div>

                <div className="greyBox p-3">
                    <div className="data-table-container" ref={tableWrapperRef}>
                        <table className="table data-table mb-0">
                            <thead className='GridHeader'>
                                {tabs.ApprovedModels === 'active' ?
                                    <tr>
                                        <th className='cursor-pointer fw-600' title={`Sort by Device Manufacturer`} onClick={() => { setSortBy({ sortColumn: 'device_manufacturer', sortDirection: sortBy.sortDirection == 'asc' ? 'desc' : 'asc' }); setCurrentPage(1); }}>Device Manufacturer <img src="/images/sortbynew.svg" alt={`Sort by Device Manufacturer`} className="img-fluid ps-2 sortbyClass" /></th>
                                        <th>Device Model</th>
                                        <th className={`${isOverflowing ? 'sticky-action' : ''}`}>Action</th>
                                    </tr>
                                    :
                                    <tr>
                                        {columnNames?.map((item, i) => {
                                            let columnName = item.replace(/_/g, ' ');
                                            const transformedName = transformNameOfCol(columnName);
                                            if (!transformedName) return null;
                                            return (
                                                <th key={item} scope="col" className='cursor-pointer fw-600' title={`Sort by ${CamelCaseWithSpaces(transformedName)}`} onClick={() => { setSortBy({ sortColumn: item, sortDirection: sortBy.sortDirection == 'asc' ? 'desc' : 'asc' }); setCurrentPage(1); }} >
                                                    {CamelCaseWithSpaces(transformedName)}
                                                    <img src="/images/sortbynew.svg" alt={`Sort by ${transformedName}`} className="img-fluid ps-2 sortbyClass" />
                                                </th>
                                            )
                                        })}
                                        <th className={`${isOverflowing ? 'sticky-action' : ''}`}>
                                            Action
                                            <img src="/images/EditHeaderIcon.svg" className="cursor-pointer  img-fluid ps-2 pe-5" title='Customize Headers' style={{ height: '25px' }} onClick={(e) => setCustomizationModal(true)} />
                                        </th>
                                    </tr>
                                }

                            </thead>
                            <tbody>
                                {tabs.ApprovedModels === 'active' ?
                                    <>
                                        {gridData?.length > 0 ? gridData?.map((item, i) => (
                                            <tr className='OddEvenClass tableBorderHide '>
                                                {["device_manufacturer", "device_model"]?.map(header => (
                                                    <td className="py-12" key={header}> {renderContentForColumn(header, item)} </td>
                                                ))}
                                                <td className={`${isOverflowing ? 'sticky-action' : ''}`}>
                                                    <img src="/images/EditIconNew.svg" title="Edit Device Model"
                                                        className="cursor-pointer img-fluid"
                                                        onClick={() => {
                                                            setShowAddModelPopup(prev => ({ ...prev, show: true, editId: item.id, addUpdateApprovalFlag: 2, data: null }));
                                                            getDeviceModelDetailsById(item.id)
                                                        }} />
                                                    <img
                                                        src="/images/DeleteIcon.svg"
                                                        title="Delete Device Model"
                                                        className="cursor-pointer img-fluid ms-3"
                                                        onClick={() => {
                                                            setDeleteModelPopup({
                                                                ...initialDeleteModelPopup,
                                                                show: true,
                                                                model: item
                                                            });
                                                        }}
                                                    />
                                                </td>
                                            </tr>
                                        )) :
                                            <tr className='OddEvenClass tableBorderHide '>
                                                <td colSpan={18} className="p-3 text-center">
                                                    No Record Found
                                                </td>
                                            </tr>
                                        }
                                    </>
                                    :
                                    <>
                                        {gridData?.length > 0 ? gridData?.map((item, i) => (
                                            <tr className='OddEvenClass tableBorderHide '>
                                                {columnNames?.map(header => (
                                                    <td className="py-12" key={header}> {renderContentForColumn(header, item)} </td>
                                                ))}
                                                <td className="py-12" key={'action'} className={`${isOverflowing ? 'sticky-action' : ''}`}>
                                                    <img src="/images/setupapprove.svg" className="cursor-pointer img-fluid"
                                                        height={18} width={18} title="Approve"
                                                        onClick={() => {
                                                            setShowAddModelPopup(prev => ({ ...prev, data: item, show: false, editId: null, addUpdateApprovalFlag: 3, approveShow: true }));
                                                            getApprovalModelDetails(item.school_id || null, item.flag || null, item.device_model_id || null, item.manufacturer_id || null);
                                                        }}
                                                    />
                                                </td>
                                            </tr>
                                        )) :
                                            <tr className='OddEvenClass tableBorderHide '>
                                                <td colSpan={18} className="p-3 text-center">
                                                    No Record Found
                                                </td>
                                            </tr>
                                        }
                                    </>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
                {showPagination &&
                    <Pagination
                        activePage={currentPage}
                        totalItemsCount={pageRangeCount}
                        pageRangeDisplayed={15}
                        itemsCountPerPage={LimitForPagination}
                        onChange={(e) => { setCurrentPage(e); }}
                        color="primary"
                        itemClassFirst="MasterClass"
                        itemClassPrev="MasterClass"
                        itemClassNext="MasterClass"
                        itemClassLast="MasterClass"
                        hideFirstLastPages={true} />
                }
            </div>

            <Popup
                isshow={showAddModelPopup.show}
                size={"lg"}
                title={`${showAddModelPopup.addUpdateApprovalFlag == 2 ? "Edit" : "Add"} Model Details`}
                modalBody={modalBodyAddEdit}
                closePopup={(e) => {
                    setNewDeviceData(initialNewDeviceData);
                    setShowAddModelPopup(initialModelState);
                    setSelectedPartIds([]);
                    setmodelData([]);
                    setSerialNumbersList([]);
                    setAllPartsData(initialAllParts);
                }}
                modalfooter={modalEditFooter}
            />


            <Popup
                isshow={showAddModelPopup.approveShow}
                size={"lg"}
                title={"Approve Model"}
                modalBody={modalBodyApprove}
                closePopup={(e) => {
                    setNewDeviceData(initialNewDeviceData);
                    setShowAddModelPopup(initialModelState);
                    setSelectedPartIds([]);
                    setmodelData([]);
                    setSerialNumbersList([]);
                    setAllPartsData(initialAllParts);
                    pendingModelMatch.current = null;
                }}
                handleSave={(e) => { handleApprove() }}
                visibleSaveBtn={true}
                btnText={"Approve Model"} />

            {CustomizationModal == true && (
                <CustomizationPopup isShow={CustomizationModal} setCustomizationModal={setCustomizationModal} tabFlag={47} gridname={'Device Models'} GetCall={() => ApiGetHeaders(47, setColumnNames)} />
            )}

            <AlertPopup
                isshow={deleteModelPopup.show}
                img="/images/redInfo.svg"
                headingtext="Delete Device Model"
                text={modalBodyDeleteModel}
                cancelcall={() => setDeleteModelPopup(initialDeleteModelPopup)}
                canceltext="Cancel"
                successtext="Yes, Delete"
                successcall={handleDeleteModel}
                btntype="deleteBtn"
            />
        </div>
    )

}